import React, { Component } from 'react';
import '../css/getListUbications.css';
import 'whatwg-fetch';
class getListUbications extends Component {
  constructor(props) {
    super(props);
    //this.mapRef = React.createRef();
    this.state = {
      list_ubicaciones : [],
      inicial:0
    }
  }
  get_go_to =(modulo_modal)=>{
    this.props.get_go_to(modulo_modal)
  }
  get_List_Ubicaciones =()=>{
    const url= this.props.dir_url + "webapp/getListUbicaciones";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'findUbicaciones', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //console.log(data)
        this.setState({
          list_ubicaciones:data[0].msg,inicial:1
        })
      }else{
        this.setState({
          list_ubicaciones : [],inicial:1
        })
      }
    })
    .catch(console.log)
  }
  mostrarUbicaciones = () => {
    const list_ubicaciones = this.state.list_ubicaciones;
    const id_ubicacion = this.props.id_ubicacion
    if(list_ubicaciones.length === 0) return null;
    return (
      <React.Fragment>
        {list_ubicaciones.map(ubicacion => (
          <div key={ubicacion.id_ubicacion} className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}}  onClick={ () => this.props.get_coordenadas(ubicacion.lat,ubicacion.lon,ubicacion.calle,Number(ubicacion.id_ubicacion))}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') }  />
            </div>
            <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter">
              <span className="span-global" >{ubicacion.calle}</span>
            </div>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
              {(Number(id_ubicacion)===Number(ubicacion.id_ubicacion))?
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  />
              :
              <React.Fragment></React.Fragment>
              }
            </div>
          </div>
        )) }

      </React.Fragment>
    )
    //console.log("id_subrubro");
  }
  render() {
    const id_ubicacion = this.props.id_ubicacion
    return (

      <div className="cssversion_menu cssversion_colorblanco">
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}  onClick={ () => this.props.get_go_to('')}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }  />
            </div>
            <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
              <span className="span-global-link" >Lista de Ubicaciones</span>
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}  onClick={ () => this.props.get_coordenadas(localStorage.lat,localStorage.lon,"Ubicación Actual",0)}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') }  />
            </div>
            <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter">
              <span className="span-global" >Ubicación Actual</span>
            </div>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
              {(Number(id_ubicacion)===0)?
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  />
              :
              <React.Fragment></React.Fragment>
              }
            </div>
          </div>
          {(this.state.inicial===0)?
            <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex"}} onClick={ () => this.getupdatedefaultFormaPago(0)}>
              <img alt="Cargando Imagen . . ." style={{"height":"50px"}} src={ require('../image/loading.gif')}/>
            </div>
            :''
          }
          {this.mostrarUbicaciones()}
          <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter">
            <button className="button-global cssversion_pw90"
            onClick={ () => this.get_go_to("newubicacion")}>Nueva Ubicación</button>
          </div>
      </div>
    );
  }
  componentDidMount (){
    this.get_List_Ubicaciones();
  }
}
export default getListUbications;
